import { useEffect, useState } from "react";
import { Flex, Tabs, Text } from "@mantine/core";
import { useNavigate, useParams } from "react-router";
import styled from "styled-components";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import ContainerLoadingOverlay from "../components/common/ContainerLoadingOverlay";
import DiagnosticsPanel from "../components/Tablets/DiagnosticsPanel";
import { getTerminalById } from "../api/terminalApi";
import { useAuth } from "../context/AuthContext";

const TabletDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState<any>("detail");
  const [tablet, setTablet] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Teşhis sekmesi HERKESE açık: özet kartlar (durum / son bilgi / sinyal /
  // sürüm / genel sağlık) İK'nın "bu kapıyı aramam gerekir mi" sorusunu
  // cevaplıyor. Ham teknik veri (heap eğrisi, reset kodu, C6 sürümü) ise
  // yalnızca admin'e açılan katlanabilir bölümde - bkz. DiagnosticsPanel.
  const isAdmin = user?.privilege === "admin";

  useEffect(() => {
    const fetchTerminal = async () => {
      setIsLoading(true);
      try {
        const res: any = await getTerminalById(id);
        setTablet(res?.data?.response || null);
      } catch (error) {
        console.error("Terminal bilgisi alınamadı", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTerminal();
  }, [id]);

  return (
    <Container>
      {isLoading ? (
        <ContainerLoadingOverlay visible={isLoading} />
      ) : (
        <>
          <PageHeader
            pageTitle={tablet?.name || "Tablet"}
            subText={tablet?.location}
            isButtoned
            buttonText="Düzenle"
            buttonOnClick={() =>
              navigate("/tablets/edit", { state: { tablet } })
            }
          />
          <Tabs value={activeTab} onChange={setActiveTab}>
            <Tabs.List mb={20} w={"max-content"}>
              <StyledTabsTab value="detail">Tablet Bilgileri</StyledTabsTab>
              <StyledTabsTab value="diagnostics">Durum</StyledTabsTab>
            </Tabs.List>

            <Tabs.Panel value="detail">
              <InfoGrid>
                <Info label="Tablet Adı" value={tablet?.name} />
                <Info label="Terminal Kodu" value={tablet?.code} />
                <Info label="Konum" value={tablet?.location} />
                <Info label="Kat" value={tablet?.floor} />
                <Info label="Adres" value={tablet?.address} />
                {/* Kayıtta "1"/"0" duruyor; ham hane ekranda anlamsızdı (plan 2.56). */}
                <Info
                  label="Otomatik Açma"
                  value={tablet?.autoControl === "1" ? "Açık" : "Kapalı"}
                />
              </InfoGrid>
            </Tabs.Panel>

            <Tabs.Panel value="diagnostics">
              <DiagnosticsPanel terminalId={id} isAdmin={isAdmin} />
            </Tabs.Panel>
          </Tabs>
        </>
      )}
    </Container>
  );
};

const Info = ({ label, value }: { label: string; value?: string }) => (
  <Flex direction="column" gap={4}>
    <Text size="xs" c="#6b7280" fw={500}>
      {label}
    </Text>
    <Text size="md" fw={400} c="#111827">
      {value || "—"}
    </Text>
  </Flex>
);

export default TabletDetail;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
  max-width: 900px;
`;

const StyledTabsTab = styled(Tabs.Tab)`
  color: #9ca3af;
  &[aria-selected="true"] {
    color: #5c26ff;
    border-color: #5c26ff;
    border-bottom-width: 3px;
  }
`;
